/* unplugin-vue-components disabled */import { render } from "./ranking.vue?vue&type=template&id=d026b368&scoped=true&ts=true"
import script from "./ranking.vue?vue&type=script&lang=ts"
export * from "./ranking.vue?vue&type=script&lang=ts"

import "./ranking.vue?vue&type=style&index=0&id=d026b368&scoped=true&lang=scss"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d026b368"]])

export default __exports__